import type { PaymentMethodKind } from '@sshop/domain';

import { backendAssetUrl } from '@/shared/lib/backendAssetUrl';

export type PaymentGroup = 'cash' | 'card' | 'bnpl' | 'installment' | 'loyalty';

export interface PaymentOption {
  readonly kind: PaymentMethodKind;
  readonly labelKey: string;
  readonly group: PaymentGroup;
  readonly image: string | null;
  readonly mark?: 'apple-pay' | 'google-pay';
}

export interface PaymentOptionGroup {
  readonly id: PaymentGroup;
  readonly labelKey: string;
  readonly options: readonly PaymentOption[];
}

const BANKS_BASE = backendAssetUrl('/client/assets/images/banks');

export const availablePaymentOptions: readonly PaymentOption[] = [
  {
    kind: 'cod',
    labelKey: 'paymentCod',
    group: 'cash',
    image: null,
  },
  {
    kind: 'bog-card',
    labelKey: 'paymentBogCard',
    group: 'card',
    image: `${BANKS_BASE}/2.png`,
  },
  {
    kind: 'bog-apple-pay',
    labelKey: 'paymentApplePay',
    group: 'card',
    image: null,
    mark: 'apple-pay',
  },
  {
    kind: 'bog-google-pay',
    labelKey: 'paymentGooglePay',
    group: 'card',
    image: null,
    mark: 'google-pay',
  },
  {
    kind: 'bog-mobile-bank',
    labelKey: 'paymentMobileBank',
    group: 'card',
    image: `${BANKS_BASE}/bog-mobile.png`,
  },
  { kind: 'tbc', labelKey: 'paymentTbc', group: 'card', image: `${BANKS_BASE}/1.png` },
  {
    kind: 'bog-bnpl',
    labelKey: 'paymentBogBnpl',
    group: 'bnpl',
    image: `${BANKS_BASE}/Untitled-3.png`,
  },
  {
    kind: 'bog-installment',
    labelKey: 'paymentBogInstallment',
    group: 'installment',
    image: `${BANKS_BASE}/2.png`,
  },
  {
    kind: 'tbc-installment',
    labelKey: 'paymentTbcInstallment',
    group: 'installment',
    image: `${BANKS_BASE}/tbc-installment-logo.svg`,
  },
  {
    kind: 'bog-loyalty',
    labelKey: 'paymentBogLoyalty',
    group: 'loyalty',
    image: `${BANKS_BASE}/loyalty.png`,
  },
];

export const paymentOptionGroups: readonly PaymentOptionGroup[] = [
  { id: 'cash', labelKey: 'paymentGroupCash', options: forGroup('cash') },
  { id: 'card', labelKey: 'paymentGroupDirect', options: forGroup('card') },
  { id: 'bnpl', labelKey: 'paymentGroupBnpl', options: forGroup('bnpl') },
  {
    id: 'installment',
    labelKey: 'paymentGroupInstallment',
    options: forGroup('installment'),
  },
  { id: 'loyalty', labelKey: 'paymentGroupLoyalty', options: forGroup('loyalty') },
];

function forGroup(group: PaymentGroup): readonly PaymentOption[] {
  return availablePaymentOptions.filter((option) => option.group === group);
}
